import config from '../../config/config';
import { UserParameters } from '../../interface/users-management.interface';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Accounts list with pagination
   */
  fetchUsers: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/users`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination
   */
  fetchUsersListFilters: (): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/users/list-filters`);
  },
  /**
   * Fetch the Single user
   */
  fetchUserActivityLogs: (id: String): Promise<any> =>
    getRequest(`${config.notificationApiUrl}api/super-admin/v1/general-log/activityLog/${id}`),
  /**
   * Fetch the Accounts list with pagination
   */
  exportUsers: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/users/export-users`, {
      ...parameters,
    });
  },
  /**
   * Create the user api call function
   * @param data
   * @returns
   */
  createUser: (
    data: UserParameters = {
      name: '',
      email: '',
      role: '',
      password: '',
      phoneNumber: '',
      countryCode: '',
    },
  ): Promise<any> => {
    const parameters = { ...data };
    return postRequest(`${config.accountApiUrl}api/super-admin/v1/users`, {
      ...parameters,
    });
  },
  /**
   * Update the user api call function
   * @param data
   * @returns
   */
  editUser: (
    id: string,
    data: UserParameters = {
      name: '',
      email: '',
      role: '',
      phoneNumber: '',
      countryCode: '',
    },
  ): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.accountApiUrl}api/super-admin/v1/users/${id}`, {
      ...parameters,
    });
  },
  /**
   * Delete the user api call function
   * @param data
   * @returns
   */
  deleteUser: (id: String): Promise<any> => {
    return deleteRequest(`${config.accountApiUrl}api/super-admin/v1/users/${id}`);
  },
};
